import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TNameTranslation {
  id: number;
  organisationId: number;
  languageId: number;
  nameTranslation: string;
  valid: boolean;
}

export interface INameTranslation extends TNameTranslation {}

const NameTranslation = Model((model: TNameTranslation): INameTranslation => {
  const _value: TNameTranslation = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },

    get organisationId() {
      return _value.organisationId;
    },
    set organisationId(value) {
      _value.organisationId = value;
    },
    get languageId() {
      return _value.languageId;
    },
    set languageId(value) {
      _value.languageId = value;
    },
    get nameTranslation() {
      return _value.nameTranslation;
    },
    set nameTranslation(value) {
      _value.nameTranslation = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    }
  };

  return ValidatableObject<INameTranslation>(_model);
});

export default NameTranslation;
